import { render, staticRenderFns } from "./FormMealBlock.vue?vue&type=template&id=9949b844"
import script from "./FormMealBlock.vue?vue&type=script&lang=js"
export * from "./FormMealBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports